import Image from 'next/image'
import { FC } from 'react'

import { RequestByIdApiType } from '@/api/models/requests'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { PageType } from '@/components/entities/requests/model/types'
import { AppButton } from '@/components/shared/button'
import { ButtonSkeleton, CardSkeleton } from '@/components/shared/skeleton'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

type Props = {
  request: RequestByIdApiType
  pageType: PageType
  isLoading: boolean
  onFormSuccess: (_: boolean) => void
}

const RequestSuccess: FC<Props> = ({
  request,
  pageType,
  isLoading,
  onFormSuccess
}) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  const { navigateToContentsFromDetails } = useRequestNavigation()

  const handleRedirectToContent = async () => {
    navigateToContentsFromDetails(pageType, request.id)
    onFormSuccess(false)
  }

  if (isLoading) {
    return (
      <div className="flex h-full flex-col justify-between">
        <CardSkeleton className="mt-[230px] h-[200px] w-full xxs:h-[384px]" />
        <div className="flex gap-10 pb-40">
          <ButtonSkeleton className="mt-20 h-[56px] w-full" />
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="mt-[-210px] flex flex-grow flex-col items-center justify-center sm:mt-0">
        <Image
          src="/images/shared/CheckMark.png"
          width={isMobileScreen ? 90 : 180}
          height={isMobileScreen ? 90 : 180}
          alt="request-plug-success"
          className="flex justify-center"
        />
        <p className="mt-22 text-center text-grey-70 text-20 sm:text-16">
          Детали и статус вы можете посмотреть в разделе «
          {pageType === PageType.Requests ? 'Обращения' : 'Пропуска'}»
        </p>
      </div>

      <AppButton
        fluid
        size={isMobileScreen ? 'small' : 'large'}
        onClick={handleRedirectToContent}
        className="mb-20 mt-auto sm:mb-10"
        variant="backless"
        data-testid="request-success-navigate-button-id"
      >
        {`Перейти к ${
          pageType === PageType.Requests ? 'обращению' : 'пропуску'
        }`}
      </AppButton>
    </>
  )
}

export { RequestSuccess }
